import { ITableURLFilter, encodeURLParams, decodeURLParams } from '@/components/UI/Table/url-filters';
import router from '@/router';

class TableFiltersService {
  private filters: ITableURLFilter = {};

  public set(filter: ITableURLFilter): void {
    Object.assign(this.filters, filter);
    this.updateURLQuery();
  }

  public get(filterName: string): Record<string, string> {
    return decodeURLParams(router.currentRoute.query.filters)[filterName];
  }

  public remove(filterName: string): void {
    delete this.filters[filterName];
    this.updateURLQuery();
  }

  private updateURLQuery(): void {
    let query;

    if (Object.keys(this.filters).length) {
      const filters = encodeURLParams(this.filters);
      query = { ...router.currentRoute.query, filters };
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { filters, ...other } = router.currentRoute.query;
      query = other;
    }

    // Throws navigation duplicated error
    router.replace({ query }).catch(e => {
      if (e.name !== 'NavigationDuplicated') {
        throw e;
      }
    });
  }
}

export default new TableFiltersService();
